import { Guid } from 'guid-typescript';

export class CreateUser {
  static readonly type = '[USER] Create User';
  constructor(public user: any) {}
}
export class GetDataByUserId {
  static readonly type = '[USER] Get User Data By User Id';
  constructor(public userId: Guid) {}
}
export class DeleteUsers {
  static readonly type = '[USER] Delete Selected Users';

  constructor(public ids: Array<Guid>) {}
}
export class SendInvite {
  static readonly type = '[USER] Send Invite';
  constructor(public userData: any) {}
}
export class GetUserPermissionsList {
  static readonly type = '[USER] Get User Permissions List';
}

export class UpdateUserClients {
  static readonly type = '[USER] Update User Clients';

  constructor(public userId: Guid, public userClients: Array<any>) {}
}

export class GetUserClients {
  static readonly type = '[USER] Get User Clients Details';

  constructor(public queryParams: any) {}
}

export class ArchiveAndRestoreUser {
  static readonly type = '[USER] Archive and Restore Selected User';

  constructor(public userIds?: Array<Guid>, public isArchive?: boolean) {}
}